import { Button, Flex, Text } from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";
import { useState } from "react";

import { withPolymorphicClickAnalytics } from "../../../../shared-utils/analytics/withPolymorphicClickAnalytics";
import classes from "./NoOfferButton.module.css";

const AnalyticsButton = withPolymorphicClickAnalytics(Button<"button">, "ButtonClick");

export function NoOfferButton() {
    const [notOffered, setNotOffered] = useState(false);

    return (
        <Flex
            bg="dark.7"
            h="4rem"
            mih="4rem"
            mah="4rem"
            align="center"
            justify="center"
            p="md"
            className={classes.root}
        >
            {notOffered ? (
                <Flex align="center" gap="xs" data-testid="no-offer-text">
                    <IconCheck size={16} />
                    <Text size="xs">Got it—no offer made</Text>
                </Flex>
            ) : (
                <AnalyticsButton
                    analytics={{ actionId: "NoOfferButton" }}
                    variant="outline"
                    color="white"
                    size="sm"
                    onClick={() => setNotOffered(true)}
                    data-testid="no-offer-button"
                >
                    <Text size="xs">I didn&apos;t make an offer</Text>
                </AnalyticsButton>
            )}
        </Flex>
    );
}
